import FirestoreDocStore from '../../../modules/vuex-firestore/FirestoreDocStore'

const state = {
  tableBackgroundImageKey: null,
  tableImageKey: null,
  tableRatio: '16:9',
  tableMode: '2d',
  bgm01SoundKey: null,
  bgm02SoundKey: null,
  se01SoundKey: null,
  youtubeId: null,
  owner: null,
  messageTabs: [{ name: '1', key: '1' }, { name: '2', key: '2' }],
  characterParamList: [{
    name: 'HP',
    key: 'hp',
    flex: true
  }, {
    name: 'MP',
    key: 'mp',
    flex: true
  }, {
    name: 'SAN',
    key: 'san',
    flex: true
  }]
}

const mutations = {}

const getters = {
  data(state) {
    return {
      tableBackgroundImageKey: state.tableBackgroundImageKey,
      tableImageKey: state.tableImageKey,
      tableRatio: state.tableRatio,
      tableMode: state.tableMode,
      bgm01SoundKey: state.bgm01SoundKey,
      bgm02SoundKey: state.bgm02SoundKey,
      se01SoundKey: state.se01SoundKey
    }
  },
  table(state) {
    return {
      backgroundImageKey: state.tableBackgroundImageKey,
      imageKey: state.tableImageKey,
      ratio: state.tableRatio,
      mode: state.tableMode,
      youtubeId: state.youtubeId
    }
  },
  tracks(state) {
    return {
      bgm01SoundKey: state.bgm01SoundKey,
      bgm02SoundKey: state.bgm02SoundKey,
      se01SoundKey: state.se01SoundKey
    }
  },
  bgm01SoundKey(state) {
    return state.bgm01SoundKey
  },
  bgm02SoundKey(state) {
    return state.bgm02SoundKey
  },
  se01SoundKey(state) {
    return state.se01SoundKey
  },
  characterParamList(state) {
    return state.characterParamList
  },
  messageTabs(state) {
    return state.messageTabs
  }
}

const actions = {}

function formatter(d) {
  return d
}

export default new FirestoreDocStore({
  $name: 'room',
  $formatter: formatter,
  state,
  mutations,
  getters,
  actions
})